const React = require('react');
const {openPopupWindow} = require('../../../../../emitters/popup');
const Popup = require('../../../../dumb/Popup/C');
const FormCreateRetailer = require("../components/FormCreateRetailer");

module.exports = () => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Create New Retailer</div>
          </div>
        )}
      >
        <FormCreateRetailer close={close} />
      </Popup>
    );
  };
});
